import React, { useEffect, useRef } from 'react';
// import { useT } from 'talkr';
import s from './index.module.scss';
import steps from '../../../survey/steps';
import logo from './img/logo.svg';
import under from './img/under.png';
import over from './img/over.png';

function AgeGroupStartScreen() {
	// const { T } = useT();
	const ref = useRef();

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'age_group_start_screen',
			stepStatus: true
		});
	}, []);

	function goForward() {
		ref.current.classList.add(`${s.ageGroupStartScreen_fade}`);
		setTimeout(() => {
			steps.navigate.forward({
				preventAction: 500
			});
			ref.current.classList.remove(`${s.ageGroupStartScreen_fade}`);
		}, 500);
	}

	return (
		<div className={s.ageGroupStartScreen} ref={ref}>
			<div>
				<div className={s.ageGroupStartScreen_header}>
					<img src={logo} alt='verv' />
				</div>
				<div className={s.ageGroupStartScreen_title}>
					1-MINUTE QUIZ
				</div>
			</div>
			<div>
				<div className={s.ageGroupStartScreen_textBig}>
					Choose your age group
				</div>
				<div className={s.ageGroupStartScreen_textSmall}>
					According to the scientific standards of the American College of Sports Medicine (ACSM), fitness programs need to be suitable for your age group.
				</div>
				<div className={s.ageGroupStartScreen_buttons}>
					<button
						onClick={goForward}
						className={s.ageGroupStartScreen_button}
						type="button">
						<img className={s.ageGroupStartScreen_button_img} src={under} alt='under 45' />
						Under 45
					</button>
					<button
						onClick={goForward}
						className={s.ageGroupStartScreen_button}
						type="button">
						<img className={s.ageGroupStartScreen_button_img} src={over} alt='over 45' />
						45 & over
					</button>
				</div>
			</div>
		</div>
	);
}

export default AgeGroupStartScreen;
